module.exports = __webpack_public_path__ + "img/FR13150.2e84c6e7.png";